import React from 'react';
import CircleComponent from '../circleComponent';
import RectangleComp from '../RectangleComp/rectangleComp';
import Styles from './comboStyle.module.scss';

interface EndpointOs {
  osName: string;
  osDisplayName: string;
  numberOfEndpoints: number;
  percentage: number;
  urlFilter: string;
  additionalInfo: Record<string, unknown>;
}

interface ComboProps {
  endpointsByOs?: EndpointOs[];
  groupId?: string | null;
}

const Combo: React.FC<ComboProps> = ({ endpointsByOs = [], groupId }) => {
  return (
    <div className={Styles.combo}>
      <CircleComponent endpointsByOs={endpointsByOs} groupId={groupId} />
      <RectangleComp />
    </div>
  );
};

export default Combo;
